<nb-card>
  <nb-card-header>
    <h6 class="text-heading">Chọn phương thức</h6>
  </nb-card-header>
  <nb-card-body>
    <button
      nbButton
      outline
      shape="semi-round"
      status="info"
      size="small"
      (click)="onNew('receive')"
    >
      <nb-icon icon="arrow-circle-up-outline"></nb-icon>
      Phiếu thu
    </button>

    <button
      nbButton
      outline
      shape="semi-round"
      status="warning"
      size="small"
      (click)="onNew('issue')"
    >
      <nb-icon icon="arrow-circle-down-outline"></nb-icon>
      Phiếu chi
    </button>
  </nb-card-body>
</nb-card>
